import { ConsumptionActionTypes } from './action-types';
import { ConsumptionState } from 'models';
import { Reducer } from 'redux';
import { ActionTypes } from '../helpers';

const initialState: ConsumptionState = {
  spaces: [],
  spacesLoading: false,
  meters: [],
  metersLoading: false,
  consumptions: [],
  consumptionsLoading: false,
  startDate: null,
  endDate: null,
  selectedSpaceId: null,
  selectedMeter: null,
  sortParams: {
    order: 'desc',
    orderBy: 'Date',
    type: 'string',
  },
  error: false,
};

export const reducer: Reducer<ConsumptionState, ActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ConsumptionActionTypes.REQUEST_CONSUMPTION_SPACES_START:
      return {
        ...state,
        spacesLoading: true,
        error: false,
      };
    case ConsumptionActionTypes.REQUEST_CONSUMPTION_SPACES_SUCCESS:
      return {
        ...state,
        spaces: action.payload,
        selectedSpaceId:
          action.payload && action.payload.length ? action.payload[0].Id : null,
        spacesLoading: false,
      };
    case ConsumptionActionTypes.REQUEST_METERS_START:
      return {
        ...state,
        metersLoading: true,
      };
    case ConsumptionActionTypes.REQUEST_METERS_SUCCESS:
      return {
        ...state,
        meters: action.payload,
        metersLoading: false,
      };
    case ConsumptionActionTypes.REQUEST_CONSUMPTIONS_START:
      return {
        ...state,
        consumptionsLoading: true,
      };
    case ConsumptionActionTypes.REQUEST_CONSUMPTIONS_SUCCESS:
      return {
        ...state,
        consumptionsLoading: false,
        consumptions: action.payload,
      };
    case ConsumptionActionTypes.SELECT_SPACE:
      return {
        ...state,
        selectedSpaceId: action.payload,
        meters: [],
        consumptions: [],
        selectedMeter: null,
        startDate: null,
        endDate: null,
      };
    case ConsumptionActionTypes.SET_SORT_PARAMS:
      return {
        ...state,
        sortParams: {
          order: state.sortParams.order === 'asc' ? 'desc' : 'asc',
          orderBy: action.payload.id,
          type: action.payload.type,
        },
      };
    case ConsumptionActionTypes.SET_START_DATE:
      return { ...state, startDate: action.payload };
    case ConsumptionActionTypes.SET_END_DATE:
      return { ...state, endDate: action.payload };
    case ConsumptionActionTypes.SELECT_METER:
      return { ...state, selectedMeter: action.payload };
    case ConsumptionActionTypes.SET_ERROR_STATUS:
      return {
        ...state,
        error: action.payload,
        spacesLoading: false,
        metersLoading: false,
        consumptionsLoading: false,
      };
    case ConsumptionActionTypes.RESET_STATE:
      return {
        spaces: [],
        spacesLoading: false,
        meters: [],
        metersLoading: false,
        consumptions: [],
        consumptionsLoading: false,
        startDate: null,
        endDate: null,
        selectedSpaceId: null,
        selectedMeter: null,
        sortParams: {
          order: 'desc',
          orderBy: 'Date',
          type: 'string',
        },
        error: false,
      };
    default:
      return state;
  }
};
